import { type PlaceBoundingBox } from '@/features/place/types/place-types';
import calculateRadians from '@/features/place/utils/calculate-radians';

export default function calculateDistance({
  latitudeNorthEast,
  latitudeSouthWest,
  longitudeNorthEast,
  longitudeSouthWest,
}: PlaceBoundingBox) {
  const R = 6371e3; // metres
  const fi1 = calculateRadians(latitudeSouthWest);
  const fi2 = calculateRadians(latitudeNorthEast);
  const dFi = calculateRadians(latitudeNorthEast - latitudeSouthWest);
  const dL = calculateRadians(longitudeNorthEast - longitudeSouthWest);

  const a = Math.sin(dFi / 2) * Math.sin(dFi / 2)
        + Math.cos(fi1) * Math.cos(fi2)
        * Math.sin(dL / 2) * Math.sin(dL / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return Number(((R * c) / 1000).toPrecision(4));
}
